export const FEATURE_TYPES = ['feedback', 'email', 'slideIn', 'tracked', 'analytics', 'password']
export const FEATURE_CARD_TITLE = 'Try this next'

export const FEATURES = {
  feedback: {
    title: 'Comment mode',
    description: 'Let visitors leave comments within your project. Great for capturing feedback!',
    illustration: '/assets/icons/progressBarIcons/Image_01-Feedback.svg',
    icon: '/assets/icons/progressBarIcons/feedback-1.svg'
  },
  email: {
    title: 'Email Capture',
    description: 'Ask visitors for their email before they can see your content.',
    illustration: '/assets/icons/progressBarIcons/Image_02-Email.svg',
    icon: '/assets/icons/progressBarIcons/email-capture-2.svg'
  },
  slideIn: {
    title: 'Slide-In Feature',
    description: 'Add a promotional slide-in to drive visitors to perform an action when they visit your link.',
    illustration: '/assets/icons/progressBarIcons/Image_03-Slide-In.svg',
    icon: '/assets/icons/progressBarIcons/slide-in-feature-3.svg'
  },
  tracked: {
    title: 'Tracked Sharing',
    description: 'Create unique tracking links for your project and get notified when someone checks your project.',
    illustration: '/assets/icons/progressBarIcons/Image_04-Tracked.svg',
    icon: '/assets/icons/progressBarIcons/tracked-sharing-4.svg'
  },
  analytics: {
    title: 'Reports & Analytics',
    description: 'Find out who visits your project with detailed analytics and reports.',
    illustration: '/assets/icons/progressBarIcons/Image_05-Analytics.svg',
    icon: '/assets/icons/progressBarIcons/report-and-analytics-5.svg'
  },
  password: {
    title: 'Password Protection',
    description: 'Ask visitors for a password before they can view your project’s content.',
    illustration: '/assets/icons/progressBarIcons/Image_06-Password.svg',
    icon: '/assets/icons/progressBarIcons/password-protection-6.svg'
  }
}
